import styled from '@emotion/styled/macro'

const MarginBlock = styled('div')`
  height: auto;
  margin-bottom: 1.5rem;
  width: 100%;
`

export { MarginBlock }
